module.exports = __webpack_public_path__ + "img/menu_close.1d76e74.png";